// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef284332","453":"52e7fe3b","455":"0b6247a1","977":"c50e612c"}[chunkId] + ".chunk.js";
};